const HeadingThree = ({ headThree, className }: { headThree: string; className?: string }) => {
    return <h3 className={`headThree dark:text-Grey20 text-bg-gray ${className}`}>{headThree}</h3>;
};

export default HeadingThree;
